<adjustment-windowsticker-summary
  *ngIf="
    product.type === 'WindowSticker' || product.type === 'CustomWindowSticker'
  "
  [product]="product"
  [index]="index"
  [subproject]="subproject"
  [multipleProducts]="multipleProducts"
  [client]="client"
></adjustment-windowsticker-summary>
<adjustment-board-summary
  *ngIf="product.type === 'Board'"
  [product]="product"
  [index]="index"
  [multipleProducts]="multipleProducts"
></adjustment-board-summary>
<adjustment-other-product-summary
  *ngIf="product.type === 'OtherProduct'"
  [product]="product"
  [index]="index"
  [multipleProducts]="multipleProducts"
></adjustment-other-product-summary>
